export const environment = {
  apiUrl: '/api'
};
